









































































































import Vue from 'vue'
import { Action, Component } from 'nuxt-property-decorator'
import { namespace } from 'vuex-class'
import { BindingHelpers } from 'vuex-class/lib/bindings'
import { CMS, Stocks, Account } from '@one/types'
import { Watch } from 'vue-property-decorator'
import { pick } from 'lodash-es'
import { ClientType } from '~/mixins/AgreementsMixin'
import OneTabs from '~/components/molecules/tabs/OneTabs.vue'

const account: BindingHelpers = namespace('account')
const stocks: BindingHelpers = namespace('stocks')
const cms: BindingHelpers = namespace('cms')

interface WarehouseSelect {
  text: string
  value: string
}

interface ChangeStateAgreementsEmitted {
  electronicInvoices: Account.Responses.InvoiceAgreement
  selectedAgreementsIds: Array<string>
  isRequiredAgreementMarked: boolean
}

interface AdditionalFieldsPayload {
  name: string,
  label: string,
  value: any
}

interface SelectOption {
  value: any,
  text: any
}

@Component({
  components: {
    OneTabs,
    OneAgreementsList: () => import('~/components/molecules/lists/OneAgreementsList.vue'),
    OneForm: () => import('~/components/molecules/forms/OneForm.vue'),
    OneTab: () => import('~/components/atoms/tabs/OneTab.vue'),
  },
  middleware: ['isNotAuthenticated'],
})
export default class Registration extends Vue {
  @stocks.Getter getWarehousesList: any
  @stocks.Action fetchWarehouses: any
  @stocks.Mutation('SELECT_CENTRAL_WAREHOUSE_IF_NOT_SELECTED')
  selectDefaultWarehouseIfNotSelected: any

  @account.Action createOrganization: any
  @cms.Getter configuration: any
  @account.Action createIndividualClient: any
  @account.Action getRegistrationSetting: any
  @account.Getter registrationSetting: any
  @cms.State(state => state.configuration.b2cRegistrationEnabled) isB2CRegistrationEnabled: any
  @Action fetchRequiredData: any
  @Action fetchHeavyData: any
  @Action fetchAuthenticatedUserData: any
  @Action clearStore: any
  @account.Action getGusData: any
  @account.Getter gusData: any

  clientType: ClientType | string = ''
  isDataFromGus: boolean = false

  basicForm: any | null = null
  individualForm: any | null = null
  companyForm: any | null = null

  isRequiredAgreementMarked: boolean = false
  selectedAgreementsIds: Array<string> = []
  electronicInvoices: Account.Responses.InvoiceAgreement = {
    content: '',
    isAccepted: false,
  }

  additionalFields: any = {}
  additionalFieldsKeys: Array<string> = []
  mainComponentClass = 'one-registration-page'
  isTinDisabled: boolean = false

  mounted() {
    this.$plugins.onMounted(this.mainComponentClass, this)
  }

  destroyed() {
    this.$plugins.onUnmounted(this.mainComponentClass)
  }

  get options() {
    return [
      {
        label: this.$parent.$i18n.t('registration.customer_label'),
        type: 'INDIVIDUAL',
        icon: 'user',
        testId: 'registration:registration-type:b2c:button',
      },
      {
        label: this.$parent.$i18n.t('registration.company_label'),
        type: 'ORGANIZATION',
        icon: 'briefcase',
        testId: 'registration:registration-type:b2b:button',
      },
    ]
  }

  get tabOptions() {
    return this.isB2CRegistrationEnabled ? this.options : this.options.splice(1, 1)
  }

  get registrationSectionHeader(): string {
    if (!this.clientType) {
      return this.$t('registration.choose_account_type') as string
    }
    const sectionLabel: any = this.isCompanyClient
      ? this.$t('registration.company_label') as string
      : this.$t('registration.customer_label') as string
    return `${this.$t('registration.account')} - ${sectionLabel.toLowerCase()}`
  }

  get tinMask(): CMS.Responses.InputMaskItem {
    return this.configuration.inputMask.tin
  }

  get tinMaskLength(): number | string {
    const maskLength: number | string = this.tinMask.mask && this.tinMask.mask.length

    return maskLength || 0
  }

  get postCodeMask(): CMS.Responses.InputMaskItem {
    return this.configuration.inputMask.postCode
  }

  get initAgreementEmail(): string {
    return this.basicForm?.veeFields?.email?.value
  }

  @Watch('gusData', { immediate: true })
  onGusDataChange() {
    if (this.gusData && this.companyForm) {
      this.companyForm.veeFields.city.value = this.gusData.city
      this.companyForm.veeFields.country.value = this.gusData.country
      this.companyForm.veeFields.company.value = this.gusData.name
      this.companyForm.veeFields.street.value = this.gusData.street
      this.companyForm.veeFields.zipCode.value = this.gusData.zipCode
      this.isDataFromGus = true
    }
  }

  initializeForms() {
    this.basicForm = {
      veeFields: {
        fullName: {
          value: '',
          type: 'text',
          label: this.$t('registration.name') as string,
          rules: 'required|max:64',
          container: {
            labelClass: 'col-md-4',
            inputClass: 'col-md-5',
          },
          testId: 'registration:basic:name:input',
        },
        email: {
          value: '',
          type: 'text',
          label: this.$t('registration.email') as string,
          rules: 'required|email',
          container: {
            labelClass: 'col-md-4',
            inputClass: 'col-md-5',
          },
          testId: 'registration:basic:email:input',
        },
        password: {
          vid: 'password',
          value: '',
          type: 'passwordAdvanced',
          label: this.$t('registration.password') as string,
          testId: 'registration:basic:password:input',
          rules: {
            required: true,
            min: 8,
            upper_case: true,
            lower_case: true,
            special_char: true,
          },
          container: {
            labelClass: 'col-md-4',
            inputClass: 'col-md-5',
          },
        },
        rePassword: {
          value: '',
          type: 'password',
          label: this.$t('registration.re_password') as string,
          testId: 'registration:basic:re-password:input',
          rules: {
            required: true,
            confirmed: 'password',
          },
          container: {
            labelClass: 'col-md-4',
            inputClass: 'col-md-5',
          },
        },
        phone: {
          value: '',
          type: 'text',
          label: this.$t('registration.phone') as string,
          rules: 'required|numeric|min:8|max:11',
          testId: 'registration:basic:phone:input',
          container: {
            labelClass: 'col-md-4',
            inputClass: 'col-md-5',
          },
        },
      },
    }
    this.companyForm = {
      veeFields: {
        tin: {
          value: '',
          type: 'text',
          label: this.$t('registration.company.tin') as string,
          rules: `required|min:${this.tinMaskLength}|max:64`,
          mask: (this.tinMask && this.tinMask.mask) || null,
          testId: 'registration:company:tin:input',
          placeholder: (this.tinMask && this.tinMask.placeholder) || null,
          container: {
            labelClass: 'col-md-4',
            inputClass: 'col-md-5',
          },
          additionalComponent: this.registrationSetting.tinService.visible
            ? {
              name: 'gusDataButton',
              component: () => import('~/components/molecules/buttons/OneButton.vue'),
              props: {
                label: this.$t('registration.get_gus_data') as string,
                testId: 'registration:company:gus:button',
                disabled: true,
              },
              events: {
                click: this.getAddressDataFromGus,
              },
            }
            : null,
          events: {
            'validity-change': (valid) => {
              if (this.companyForm?.veeFields?.tin?.additionalComponent) {
                this.companyForm.veeFields.tin.additionalComponent.props.disabled = !valid
              }
            },
            input: () => {
              if (!this.registrationSetting.tinService.tinVerificationRequired ||
                !this.registrationSetting.tinService.visible ||
                !this.isDataFromGus
              ) {
                return
              }
              this.companyForm.veeFields.city.value = ''
              this.companyForm.veeFields.country.value = ''
              this.companyForm.veeFields.company.value = ''
              this.companyForm.veeFields.street.value = ''
              this.companyForm.veeFields.zipCode.value = ''
              this.isDataFromGus = false
            },
          },
        },
        company: {
          value: '',
          type: 'text',
          label: this.$t('registration.company.name') as string,
          rules: 'required|max:128',
          disabled: this.isTinDisabled,
          testId: 'registration:company:name:input',
          container: {
            labelClass: 'col-md-4',
            inputClass: 'col-md-5',
          },
        },
        street: {
          value: '',
          type: 'text',
          label: this.$t('registration.company.street') as string,
          rules: 'required',
          disabled: this.isTinDisabled,
          testId: 'registration:company:street:input',
          container: {
            labelClass: 'col-md-4',
            inputClass: 'col-md-5',
          },
        },
        zipCode: {
          value: '',
          type: 'text',
          label: this.$t('registration.company.zip_code') as string,
          rules: 'required|max:64',
          mask: (this.postCodeMask && this.postCodeMask.mask) || null,
          placeholder: (this.postCodeMask && this.postCodeMask.placeholder) || null,
          disabled: this.isTinDisabled,
          container: {
            labelClass: 'col-md-4',
            inputClass: 'col-md-2',
          },
          testId: 'registration:company:zip-code:input',
        },
        city: {
          value: '',
          type: 'text',
          label: this.$t('registration.company.city') as string,
          rules: 'required|max:64',
          disabled: this.isTinDisabled,
          container: {
            labelClass: 'col-md-4',
            inputClass: 'col-md-5',
          },
          testId: 'registration:company:city:input',
        },
        country: {
          hide: !this.registrationSetting.country.visible,
          value: '',
          type: 'selectCountry',
          disabled: this.isTinDisabled,
          label: this.$t('registration.company.country') as string,
          container: {
            labelClass: 'col-md-4',
            inputClass: 'col-md-5',
          },
          testId: 'registration:company:country:input',
        },
        accountManagerId: {
          hide: !this.registrationSetting.accountManagerId.visible,
          value: '',
          type: 'text',
          label: this.$t('registration.company.code_guardian') as string,
          rules: 'max:64',
          testId: 'registration:company:account-manager-id:input',
          container: {
            labelClass: 'col-md-4',
            inputClass: 'col-md-5',
          },
        },
        warehouseId: {
          hide: !this.registrationSetting.warehouseId.visible,
          value: '',
          type: 'select',
          options: this.selectableWarehouses,
          label: this.$t('registration.company.department') as string,
          rules: '',
          container: {
            labelClass: 'col-md-4',
            inputClass: 'col-md-5',
          },
          testId: 'registration:company:warehouse-id:select',
        },
        ...this.additionalFields,
      },
    }
    this.individualForm = {
      veeFields: {
        street: {
          value: '',
          type: 'text',
          label: this.$t('registration.company.street') as string,
          testId: 'registration:individual:street:input',
          rules: 'required',
          container: {
            labelClass: 'col-md-4',
            inputClass: 'col-md-5',
          },
        },
        zipCode: {
          value: '',
          type: 'text',
          label: this.$t('registration.company.zip_code') as string,
          testId: 'registration:individual:zip-code:input',
          rules: 'required|max:64',
          mask: (this.postCodeMask && this.postCodeMask.mask) || null,
          placeholder: (this.postCodeMask && this.postCodeMask.placeholder) || null,
          container: {
            labelClass: 'col-md-4',
            inputClass: 'col-md-2',
          },
        },
        city: {
          value: '',
          type: 'text',
          label: this.$t('registration.company.city') as string,
          testId: 'registration:individual:city:input',
          rules: 'required|max:64',
          container: {
            labelClass: 'col-md-4',
            inputClass: 'col-md-5',
          },
        },
        country: {
          // When hidden in CMS, make sure the defaultValue is set
          hide: !this.registrationSetting.country.visible,
          value: '',
          type: 'selectCountry',
          label: this.$t('registration.company.country') as string,
          testId: 'registration:individual:country:input',
          rules: 'required',
          container: {
            labelClass: 'col-md-4',
            inputClass: 'col-md-5',
          },
        },
        accountManagerId: {
          hide: !this.registrationSetting.accountManagerId.visible,
          value: '',
          type: 'text',
          label: this.$t('registration.company.code_guardian') as string,
          testId: 'registration:individual:account-manager-id:input',
          rules: 'max:64',
          container: {
            labelClass: 'col-md-4',
            inputClass: 'col-md-5',
          },
        },
        warehouseId: {
          hide: !this.registrationSetting.warehouseId.visible,
          value: '',
          type: 'select',
          options: this.selectableWarehouses,
          label: this.$t('registration.company.department') as string,
          testId: 'registration:individual:warehouse-id:select',
          rules: '',
          container: {
            labelClass: 'col-md-4',
            inputClass: 'col-md-5',
          },
        },
        ...this.additionalFields,
      },
    }
  }

  async created() {
    if (!this.isB2CRegistrationEnabled) {
      this.clientType = 'ORGANIZATION'
    }
    try {
      await this.fetchWarehouses()
      await this.getRegistrationSetting()
      await this.getAdditionalFields()
      this.isTinDisabled = this.registrationSetting.tinService.tinVerificationRequired && this.registrationSetting.tinService.visible
      this.initializeForms()
    } catch (error) {
      console.warn('Failed ', error)
    }
  }

  validate(context: any) {
    return context.store.state.cms.configuration.registrationEnabled
  }

  get selectableWarehouses() {
    return [
      { value: '', text: this.$t('header.choose_office') as string },
      ...this.getWarehousesList
        .filter(({ pickupPoint }: Stocks.Warehouse) => pickupPoint)
        .map(
          ({ id, label, name }: Stocks.Warehouse): WarehouseSelect => ({
            value: id,
            text: label || name,
          }),
        ),
    ]
  }

  get isCompanyClient(): boolean {
    return this.clientType === 'ORGANIZATION'
  }

  get addressSectionTitle(): any {
    return this.isCompanyClient
      ? this.$t('registration.invoice') as string
      : this.$t('registration.address') as string
  }

  async isIndividualClientValid() {
    const isBasicFormValid: boolean = await this.basicForm.validate()
    const isIndividualClientFormValid: boolean = await this.individualForm.validate()
    return isBasicFormValid && isIndividualClientFormValid
  }

  async isCompanyClientValid() {
    const isBasicFormValid: boolean = await this.basicForm.validate()
    const isCompanyFormValid: boolean = await this.companyForm.validate()
    return isBasicFormValid && isCompanyFormValid
  }

  async getAdditionalFields() {
    return await this.$api.account.app.getAdditionalFieldsVisible('frontend-registration')
      .then(({ data }: any) => {
        if (data.metadata) {
          // eslint-disable-next-line
          data.metadata.frontend?.forEach((item: Account.Responses.AdditionalFieldsMetadataElement) => { data[item.vid].container = item.container })
          delete data.metadata
        }
        this.additionalFields = data
        this.additionalFieldsKeys = Object.keys(data)
      })
  }

  onRegisterClick() {
    if (this.isCompanyClient) {
      return this.registerCompanyClient()
    }
    return this.registerIndividualClient()
  }

  mapFormFields(form: string) {
    // @ts-ignore
    const { veeFields }: any = this[form]
    return Object.keys(veeFields)
      .map((fieldKey: string) => ({
        [fieldKey]: veeFields[fieldKey].value,
      }))
      .reduce((all, single) => ({ ...all, ...single }), {})
  }

  mapAdditionalFields(): AdditionalFieldsPayload | {} {
    if (!this.additionalFields) { return {} }
    const formValues = pick(this.mapFormFields('individualForm'), this.additionalFieldsKeys)
    const additionalFields: any = {}
    Object.keys(formValues).forEach((item: string) => {
      return (additionalFields[item] = {
        name: item,
        label: this.additionalFields[item].label,
        value: this.getAdditionalFieldValue(formValues, item),
      })
    })

    return {
      ...additionalFields,
    }
  }

  getAdditionalFieldValue(formValues: {} | any, item: string): string | null {
    if (this.additionalFields[item].type === 'select') {
      return this.additionalFields[item].options.find((el: SelectOption) => el.value === formValues[item]).text
    }

    return formValues[item]
  }

  updateRegistrationAgreements(item: ChangeStateAgreementsEmitted) {
    this.isRequiredAgreementMarked = item.isRequiredAgreementMarked
    this.selectedAgreementsIds = item.selectedAgreementsIds
    this.electronicInvoices = item.electronicInvoices
  }

  transformCompanyRegistrationData(): any {
    const { email, phone, fullName, password } = this.mapFormFields('basicForm')
    const {
      tin,
      company,
      street,
      zipCode,
      city,
      country,
      warehouseId,
      accountManagerId,
    } = this.mapFormFields('companyForm')
    return {
      accountManagerId: accountManagerId || null,
      tin,
      isTaxPayer: true,
      admin: {
        name: fullName,
        agreementTemplateIds: this.selectedAgreementsIds,
        email,
        password,
        phone,
      },
      invoiceAgreement: this.electronicInvoices.isAccepted,
      invoiceEmail: this.electronicInvoices.email,
      phone,
      address: {
        isDefault: true,
        name: company,
        street,
        zipCode,
        city,
        country: country || null,
        phone,
      },
      warehouseId: (warehouseId && warehouseId.trim()) || null,
      additionalFields: this.mapAdditionalFields(),
    }
  }

  transformIndividualClientRegistrationData() {
    const { email, phone, fullName, password } = this.mapFormFields('basicForm')
    const { street, zipCode, city, country, warehouseId, accountManagerId } = this.mapFormFields(
      'individualForm',
    )
    return {
      accountManagerId: accountManagerId || null,
      address: {
        isDefault: true,
        name: fullName,
        street: street,
        zipCode: zipCode,
        city: city,
        country: country || null,
        phone: phone,
      },
      agreementTemplateIds: this.selectedAgreementsIds,
      invoiceAgreement: this.electronicInvoices.isAccepted,
      invoiceEmail: this.electronicInvoices.email,
      name: fullName,
      email,
      password,
      phone,
      warehouseId: (warehouseId && warehouseId.trim()) || null,
      additionalFields: this.mapAdditionalFields(),
    }
  }

  async registerCompanyClient() {
    const isRegistrationValid = await this.isCompanyClientValid()
    if (this.isRequiredAgreementMarked) {
      if (isRegistrationValid) {
        const payload: any = this.transformCompanyRegistrationData()
        this.createOrganization(payload)
          .then(() => {
            this.loginToAccount()
            this.$gtm.generateLead()
            this.$notify({
              group: 'alert',
              type: 'success',
              text: this.$t('registration.success') as string,
            })
          })
          .catch(({ response }: any) => {
            this.$notify({
              group: 'alert',
              type: 'error',
              text: this.$utils.errorHandler(response.data),
            })
          })
      } else {
        this.$notify({
          group: 'alert',
          type: 'error',
          text: this.$t('registration.isNotValid') as string,
        })
      }
    } else {
      this.$notify({
        group: 'alert',
        type: 'error',
        text: this.$t('registration.isNotValid') as string,
      })
    }
  }

  async registerIndividualClient() {
    const isIndividualClientValid = await this.isIndividualClientValid()
    if (this.isRequiredAgreementMarked) {
      if (isIndividualClientValid) {
        const payload: any = this.transformIndividualClientRegistrationData()
        this.createIndividualClient(payload)
          .then(() => {
            this.loginToAccount()
            this.$gtm.generateLead()
            this.$notify({
              group: 'alert',
              type: 'success',
              text: this.$t('registration.success') as string,
            })
          })
          .catch(({ response }: any) => {
            this.$notify({
              group: 'alert',
              type: 'error',
              text: this.$utils.errorHandler(response.data),
            })
          })
      } else {
        this.$notify({
          group: 'alert',
          type: 'error',
          text: this.$t('registration.isNotValid') as string,
        })
      }
    } else {
      this.$notify({
        group: 'alert',
        type: 'error',
        text: this.$t('registration.isNotValid') as string,
      })
    }
  }

  loginToAccount() {
    const { email, password } = this.mapFormFields('basicForm')
    this.$auth
      .login({
        email,
        password,
      })
      .then(() => {
        this.$router.push(`${this.localePath('index')}`, async () => {
          await this.clearStore()
          this.$api.invalidateAllInstances()
          await this.fetchRequiredData()
          await this.fetchAuthenticatedUserData()
          this.selectDefaultWarehouseIfNotSelected()
          this.fetchHeavyData()
        })
      })
      .catch(() => {
        this.$notify({
          group: 'alert',
          type: 'error',
          text: this.$t('login_page.incorrect_login') as string,
        })
      })
  }

  getAddressDataFromGus() {
    this.getGusData(this.companyForm.veeFields.tin.value)
      .then((data: Account.Responses.BillingAddress) => {
        if (!data) {
          this.$notify({
            group: 'alert',
            type: 'error',
            text: this.$t('registration.tin_not_found') as string,
          })
        } else {
          this.$notify({
            group: 'alert',
            type: 'success',
            text: this.$t('registration.data_downloaded') as string,
          })
        }
      })
      .catch(() => {
        this.$notify({
          group: 'alert',
          type: 'error',
          text: this.$t('registration.data_download_error') as string,
        })
      })
  }
}
